{
  "id": 16,
  "location": "cafe",
  "difficulty": "normal",
  "moves": 14,
  "kinds": 5,
  "goals": [
    { "type": "collect", "kind": "cupcake", "count": 30 }
  ],
  "stars": [3200, 4390],
  "board": [
    "# # # . . # # #",
    "# # . . . . # #",
    "# . . . . . . #",
    ". . . . . . . .",
    ". . . . . . . .",
    "# . . . . . . #",
    "# # . . . . # #",
    "# # # . . # # #"
  ],
  "calibration": { "runs": 1000, "winRate": 0.832, "movesLeft": 3.6, "closeLosses": 0.076, "target": 0.81 }
}
